export const name = 'bookingsWixCodeSdk' as const
export const namespace = 'bookings' as const
